/* Vast Trades mobile helpers – assets/vt-mobile.js
   1) Filters toggle on collection pages (<750px)
   2) Swipe left/right on the main product image to change photo + "3 / 12" counter */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* ---- 1. Filters toggle ---- */
    var aside = document.querySelector('.collection-products__filters');
    var toolbar = document.querySelector('.collection-products__toolbar');
    if (aside && toolbar && !document.querySelector('.vt-filter-toggle')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vt-filter-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', 'vt-filters');
      aside.id = aside.id || 'vt-filters';
      var active = /[?&]filter\./.test(location.search);
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 5h18M6 12h12M10 19h4"/></svg>Filter' + (active ? ' •' : '');
      btn.addEventListener('click', function () {
        var open = aside.classList.toggle('vt-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) aside.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      toolbar.appendChild(btn);
      /* place the filter panel right under the toolbar on phones */
      if (window.matchMedia('(max-width: 749px)').matches) toolbar.insertAdjacentElement('afterend', aside);
    }

    /* ---- 2. Swipeable gallery ---- */
    var main = document.querySelector('.product-gallery__main');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumbnail'));
    if (!main || thumbs.length < 2) return;
    var img = main.querySelector('.product-gallery__image');
    var counter = document.createElement('span');
    counter.className = 'vt-gallery-count';
    main.appendChild(counter);

    function idx() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('product-gallery__thumbnail--active')) return i;
      return 0;
    }
    function show(i) {
      i = (i + thumbs.length) % thumbs.length;
      var t = thumbs[i], ti = t.querySelector('img');
      thumbs.forEach(function (x) { x.classList.remove('product-gallery__thumbnail--active'); });
      t.classList.add('product-gallery__thumbnail--active');
      if (img && ti) {
        var base = (ti.currentSrc || ti.src).replace(/([?&])width=\d+/, '$1width=');
        img.removeAttribute('srcset');
        img.src = base.replace(/width=(&|$)/, 'width=1200$1');
        img.alt = ti.alt || img.alt;
      }
      var m = main.querySelector('.product-gallery__media');
      if (m && t.dataset.mediaId) m.setAttribute('data-media-id', t.dataset.mediaId);
      t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      counter.textContent = (i + 1) + ' / ' + thumbs.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    counter.textContent = (idx() + 1) + ' / ' + thumbs.length;

    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(idx() + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
  });
})();